// extracted by mini-css-extract-plugin
export var activityContainer = "_lw-0";
export var typingIndicatorContainer = "_lw-1";
export var typingIndicatorDot = "_lw-2";
export var wave = "_lw-3";